export default __webpack_public_path__ + "assets/464946410cff4b6d00ddcab50ea85499.svg";